// extracted by mini-css-extract-plugin
module.exports = {"container":"PalletScreenComponent_container__3M204","viewItems":"PalletScreenComponent_viewItems__1v5eE"};